import ApiService from "@/core/services/api.service";

// action types
export const FETCH_ADMIN_TICKETS = "fetchAdminTickets";

// mutation types
export const SET_ADMIN_TICKETS = "setAdminTickets";
export const SET_ADMIN_TICKETS_PAGINATION = "setAdminTicketsPagination";

const state = {
  adminTickets: [],
  adminTicketsPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  }
};

const getters = {
  adminTickets(state) {
    return state.adminTickets;
  },
  adminTicketsPagination(state) {
    return state.adminTicketsPagination;
  }
};

const actions = {
  [FETCH_ADMIN_TICKETS](context, payload) {
    let params = {
      page: context.state.adminTicketsPagination.currentPage,
      priority: payload.priority,
      status: payload.status,
      title: payload.title
    };
    return new Promise((resolve, reject) => {
      ApiService.query("admin/tickets", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_ADMIN_TICKETS, data.data);
          context.commit(SET_ADMIN_TICKETS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_ADMIN_TICKETS](state, data) {
    state.adminTickets = data;
  },
  [SET_ADMIN_TICKETS_PAGINATION](state, data) {
    state.adminTicketsPagination = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
